import React from "react";
import { string, func } from "prop-types";
import { refreshIframe } from "../../../creative-ad-builder/utils";

const propTypes = {
  buttonText: string,
  iframeSelector: string.isRequired,
  onClick: func
};

const ReplayButton = ({ buttonText = null, iframeSelector, onClick = null }) => {
  const handleClick = () => {
    onClick();

    refreshIframe(iframeSelector);
  };
  return (
    <span
      role="button"
      tabIndex={0}
      className="cursor-pointer text-home-hover font-size-13 font-weight-semi-bold ml-auto"
      onClick={handleClick}
      onKeyUp={handleClick}
    >
      <i className="fa fa-arrow-rotate-right" />
      {buttonText && <span className="ml-1">{buttonText}</span>}
    </span>
  );
};

ReplayButton.propTypes = propTypes;

export default ReplayButton;
